import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-[rgba(var(--glass),0.72)] backdrop-blur border-t border-slate-700/60 py-10 text-slate-200">
      {/* upper area*/}
      <div
  className="flex flex-col md:flex-row justify-center items-center md:items-start 
             gap-16 md:gap-52 px-6 md:px-20 text-center md:text-right"
>
  {/* menu */}
  <ul className="space-y-2 text-lg">
    <li>
      <Link
        to="/"
        className="text-xl hover:text-white transition-colors cursor-pointer"
      >
        דף הבית
      </Link>
    </li>
    <li>
      <Link
        to="/gallery"
        className="text-xl hover:text-white transition-colors cursor-pointer"
      >
        גלריה
      </Link>
    </li>
    <li>
      <Link
        to="/projects"
        className="text-xl hover:text-white transition-colors cursor-pointer"
      >
        פרוייקטים
      </Link>
    </li>
    <li>
      <Link
        to="/about"
        className="text-xl hover:text-white transition-colors cursor-pointer"
      >
        אודות
      </Link>
    </li>
  </ul>

  {/* contact*/}
  <ul className="space-y-3 text-lg">
    <li className="text-xl flex items-center justify-center md:justify-start gap-2 hover:text-white transition-colors cursor-pointer">
      <a
        href="https://www.instagram.com/moyal.glass?igsh=Z2xxZDk3eXpxZDQ4"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2"
      >
        <i className="bi bi-instagram text-2xl"></i>
        אינסטגרם
      </a>
    </li>

    <li className="text-xl flex items-center justify-center md:justify-start gap-2 hover:text-white transition-colors cursor-pointer">
      <a
        href="https://wa.me/972543998043"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          if (window.gtag_report_conversion) {
            window.gtag_report_conversion('https://wa.me/972543998043');
          }
        }}
        className="flex items-center gap-2"
      >
        <i className="bi bi-whatsapp text-2xl"></i>
        וואטסאפ
      </a>
    </li>

    <li className="text-center md:text-right text-slate-300">
    <i className="bi bi-telephone"></i>{" "}
      <span className="text-xl hover:text-white transition-colors cursor-pointer">
        054-3998043
      </span>
    </li>
  </ul>
</div>

      {/* low message */}
      <div className="text-center mt-10 text-slate-400 text-sm border-t border-slate-700/60 pt-5">
        כל הזכויות שמורות - מויאל זכוכיות {new Date().getFullYear()} ©
      </div>
    </footer>
  );
}
